import { useRef } from 'react';
import { Outlet } from 'react-router-dom';

import { useNinpoCore } from '../hooks/useNinpoCore';
import { CoreProvider } from '../../lib/coreContext';
import AppShellLayout from '../../layouts/appShellLayout';
import { getDeploySurface, surfaceRequiresPrivilegedLogin } from '../../lib/deploySurface';

export type { AppRouteContext } from '../routeContext';

export default function StaffAppShell() {
  const core = useNinpoCore();
  const surface = getDeploySurface();
  const openLoginRef = useRef<(() => void) | null>(null);
  const openLogin = () => {
    openLoginRef.current?.();
  };

  return (
    <CoreProvider value={core}>
      <AppShellLayout
        core={core}
        surface={surface}
        requirePrivilegedLogin={surfaceRequiresPrivilegedLogin(surface)}
        openLoginRef={openLoginRef}
      >
        <Outlet
          context={{
            core,
            openLogin,
            addToCart: () => {},
            findProductByIdentifier: () => undefined,
            getCanonicalCartId: (id: string) => id
          }}
        />
      </AppShellLayout>
    </CoreProvider>
  );
}
